// Eminem Songs - Ranked by Streaming Popularity
// Difficulty: DIFFICULT - Hip-hop chart knowledge required

export const eminemSongsData = [
  { id: 1, name: "Lose\nYourself", rank: 1, image: "/images/eminem/lose_yourself.png" },
  { id: 2, name: "Till I\nCollapse", rank: 2, image: "/images/eminem/till_i_collapse.png" },
  { id: 3, name: "Love the\nWay You\nLie", rank: 3, image: "/images/eminem/love_the_way_you_lie.png" },
  { id: 4, name: "Without\nMe", rank: 4, image: "/images/eminem/without_me.png" },
  { id: 5, name: "Not\nAfraid", rank: 5, image: "/images/eminem/not_afraid.png" },
  { id: 6, name: "Rap God", rank: 6, image: "/images/eminem/rap_god.png" },
  { id: 7, name: "The Real\nSlim\nShady", rank: 7, image: "/images/eminem/the_real_slim_shady.png" },
  { id: 8, name: "Godzilla", rank: 8, image: "/images/eminem/godzilla.png" },
  { id: 9, name: "Stan", rank: 9, image: "/images/eminem/stan.png" },
  { id: 10, name: "Mockingbird", rank: 10, image: "/images/eminem/mockingbird.png" },
  { id: 11, name: "The\nMonster", rank: 11, image: "/images/eminem/the_monster.png" },
  { id: 12, name: "River", rank: 12, image: "/images/eminem/river.png" },
  { id: 13, name: "Superman", rank: 13, image: "/images/eminem/superman.png" },
  { id: 14, name: "When I'm\nGone", rank: 14, image: "/images/eminem/when_im_gone.png" },
  { id: 15, name: "My Name\nIs", rank: 15, image: "/images/eminem/my_name_is.png" },
  { id: 16, name: "Sing for\nthe\nMoment", rank: 16, image: "/images/eminem/sing_for_the_moment.png" },
  { id: 17, name: "Cleanin'\nOut My\nCloset", rank: 17, image: "/images/eminem/cleanin_out_my_closet.png" },
  { id: 18, name: "Beautiful", rank: 18, image: "/images/eminem/beautiful.png" },
  { id: 19, name: "Venom", rank: 19, image: "/images/eminem/venom.png" },
  { id: 20, name: "Space\nBound", rank: 20, image: "/images/eminem/space_bound.png" },
  { id: 21, name: "Lucky\nYou", rank: 21, image: "/images/eminem/lucky_you.png" },
  { id: 22, name: "Killshot", rank: 22, image: "/images/eminem/killshot.png" },
  { id: 23, name: "No Love", rank: 23, image: "/images/eminem/no_love.png" },
  { id: 24, name: "Shake\nThat", rank: 24, image: "/images/eminem/shake_that.png" },
  { id: 25, name: "Like Toy\nSoldiers", rank: 25, image: "/images/eminem/like_toy_soldiers.png" },
  { id: 26, name: "Just\nLose It", rank: 26, image: "/images/eminem/just_lose_it.png" },
  { id: 27, name: "We Made\nYou", rank: 27, image: "/images/eminem/we_made_you.png" },
  { id: 28, name: "Crack a\nBottle", rank: 28, image: "/images/eminem/crack_a_bottle.png" },
  { id: 29, name: "The Way\nI Am", rank: 29, image: "/images/eminem/the_way_i_am.png" },
  { id: 30, name: "Forgot\nAbout\nDre", rank: 30, image: "/images/eminem/forgot_about_dre.png" },
];
